// extracted by mini-css-extract-plugin
export default {"buyersList":"styles_buyersList__QxOhx","noResults":"styles_noResults__7rl-n"};